import { IconTypesProps } from './iconTypes'

const SvgStatusWarning = ({
    primaryColor = '#010101',
    secondaryColor = '#EADB03',
    reverse,
    dataTestId,
}: IconTypesProps) => {
    if (reverse) {
        const tempPrimaryColor = primaryColor
        primaryColor = secondaryColor
        secondaryColor = tempPrimaryColor
    }
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            data-testid={dataTestId}
        >
            <circle cx="12" cy="12" r="12" fill={secondaryColor} />
            <path
                d="M9.59961 15.4498L11.9996 13.0498L14.3996 15.4498L11.9996 17.8498L9.59961 15.4498Z"
                fill={primaryColor}
            />
            <path
                d="M9.59961 8.5499L11.9996 6.1499L14.3996 8.5499L11.9996 10.9499L9.59961 8.5499Z"
                fill={primaryColor}
            />
        </svg>
    )
}

export default SvgStatusWarning
